import React from "react";
import { Fab, Badge, Tooltip } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";

interface ChatBubbleProps {
  unreadCount: number;
  onClick: () => void;
  isOpen: boolean;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({
  unreadCount,
  onClick,
  isOpen,
}) => {
  if (isOpen) return null;

  return (
    <Tooltip title="Project Chat" placement="left">
      <Fab
        color="primary"
        aria-label="project chat"
        onClick={onClick}
        sx={{
          position: "fixed",
          bottom: 80,
          right: 24,
          zIndex: 1300,
          transition: "transform 0.2s",
          "&:hover": {
            transform: "scale(1.1)",
          },
          "@media print": {
            display: "none !important",
          },
        }}
      >
        <Badge
          badgeContent={unreadCount > 99 ? "99+" : unreadCount}
          color="error"
          invisible={unreadCount === 0}
          sx={{
            "& .MuiBadge-badge": {
              top: -8,
              right: -8,
              minWidth: 20,
              height: 20,
              fontSize: "0.75rem",
            },
          }}
        >
          <ChatIcon />
        </Badge>
      </Fab>
    </Tooltip>
  );
};

export default ChatBubble;
